import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import "./Language.css";
import italianoIcon from "./flag/italiano.png";
import ingleseIcon from "./flag/inglese.png";
import tedescoIcon from "./flag/tedesco.png";
import franceseIcon from "./flag/francese.png";

const options = [
  { value: "it", icon: italianoIcon },
  { value: "en", icon: ingleseIcon },
  { value: "de", icon: tedescoIcon },
  { value: "fr", icon: franceseIcon },
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    padding: "5px",
    borderColor: "#ccc",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)",
    cursor: "pointer",
  }),
  option: (provided, state) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    backgroundColor: state.isSelected ? "#007bff" : "#fff",
    color: state.isSelected ? "#fff" : "#000",
    padding: "10px",
  }),
  singleValue: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

const formatOptionLabel = ({ icon }) => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <img src={icon} alt="" style={{ width: 20, height: 20, marginRight: 10 }} />
  </div>
);

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleChange = (selectedOption) => {
    i18n.changeLanguage(selectedOption.value);
  };

  return (
    <div className="language-container">
      <Select
        id="language-select"
        options={options}
        styles={customStyles}
        formatOptionLabel={formatOptionLabel}
        onChange={handleChange}
        isSearchable={false} // Aggiunto per disabilitare la ricerca
        defaultValue={options.find((option) => option.value === i18n.language)}
      />
    </div>
  );
};

export default LanguageSelector;
